import { VertiNodeLocale, type VertiNodeLocalizedString } from "../VertiNodeLocale.js";

export const newsPathMap = {
	[VertiNodeLocale.cs]: "novinky",
	[VertiNodeLocale.en]: "news",
} satisfies VertiNodeLocalizedString;
